import { Component, Inject, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TimeHlp } from 'src/lib/fliko/helpers/time.helper';
import { TenancyAgreementData } from 'src/lib/fliko/models/agreements/tenancyAgr.data';
import { GenericNote, NoteType } from 'src/lib/fliko/models/notes/notes.data';
import { ErrorHandlingService } from 'src/app/shared/error-handling/error-handling.service';
import { PushIdService } from 'src/app/shared/services/pushId.service';
import { SnackBarService } from 'src/app/shared/services/snackBar.service';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { AgreementService } from '../../../services/agreement.service';
import { NoteService } from '../../../services/note.service';

@Component({
  selector: 'app-users-prs-agreement-archive',
  templateUrl: './users-prs-agreement-archive.component.html',
  styleUrls: ['./users-prs-agreement-archive.component.scss']
})
export class UsersPrsAgreementArchiveComponent implements OnInit {
  public agreementData!: TenancyAgreementData;

  public dateForm = new FormControl();
  public noteForm = new FormControl('', [Validators.max(800)]);

  constructor(
    @Inject(MAT_DIALOG_DATA) data: TenancyAgreementData,
    private dialogRef: MatDialogRef<UsersPrsAgreementArchiveComponent>,
    private errorHandlingService: ErrorHandlingService,
    private snackBarService: SnackBarService,
    private agreementService: AgreementService,
    private noteService: NoteService,
    private pushId: PushIdService,
    private ctxDS: ContextDataService
  ) {
    this.agreementData = data;
    this.dateForm.setValue(new Date(), { emitEvent: false });
    this.dateForm.setValidators(Validators.required);
    this.dateForm.updateValueAndValidity();
  }

  ngOnInit(): void {}

  public async submit(): Promise<void> {
    if (this.dateForm.invalid) {
      this.errorHandlingService.showInvalidFormWarning();
      return;
    }
    const newEndDate = new Date(this.dateForm.value).setHours(0, 0, 0, 0);
    const newAgreement: TenancyAgreementData = {
      ...this.agreementData,
      infiniteTimePeriod: false,
      agreementEndDate: newEndDate,
      formerEndDate: this.agreementData.infiniteTimePeriod ? -1 : (this.agreementData.agreementEndDate ?? 0)
    };
    // FIXME:  One place in code without localization, because we don't have notes translation for dynamic elements
    const archiveNote: GenericNote = {
      id: this.pushId.create(),
      title: `Ręczna archiwizacja umowy z datą ${formatDate(newEndDate, 'dd.MM.yyyy', 'pl-PL')}`,
      description: this.noteForm.value,
      lastUpdate: Date.now(),
      refId: this.agreementData.id,
      userId: this.ctxDS.peekCurrentUserId()
    };
    try {
      await this.agreementService.updatePrsAgreement(newAgreement);
      await this.noteService.setNote(NoteType.AGREEMENT, archiveNote);
      this.snackBarService.showSuccess({ key: 'success.archiveAgr', replaceMap: { $number: newAgreement.agreementNumber } });
    } catch (e) {
      this.errorHandlingService.showGlobalError(
        { key: 'error.archiveAgr', replaceMap: { $number: newAgreement.agreementNumber } },
        e
      );
    }
    this.dialogRef.close({ agreement: newAgreement });
  }

  public getMinDate() {
    return new Date(TimeHlp.add(new Date(this.agreementData.agreementStartDate), 1, 'DAY'));
  }

  public getMaxDate() {
    return new Date(new Date().setHours(0, 0, 0, 0));
  }
}
